var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"loading":_vm.loading,"icon":"mdi-delete","title":"Cancel Order & Payment","color":"error"},on:{"click":_vm.handleSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }